module.exports = __webpack_public_path__ + "img/tour-33.85d28707.png";